import { useConditionalFeature } from '@americanexpress/conditional-features';
import { useConfigContext } from '../contexts/configContext';
import { hasChildAgeDropdownMaxEleven } from '../constants/featureConstants';

export function useChildAgeRange() {
  const { maxChildAge, hasInfants } = useConfigContext();
  const hasMaxAgeOfEleven = useConditionalFeature(hasChildAgeDropdownMaxEleven);

  const min = hasInfants ? 2 : 0;
  const max = hasMaxAgeOfEleven ? 11 : maxChildAge;

  return { min, max };
}
